<template>
  <nav class="navbar">
    <div class="header-line">
      <div class="navbar__item">
        <Humberger />
      </div>
      <a id="navbar__brand" :href="baseMediaportalUrl + '/'">
        <img
          class="wed-junbi-logo"
          :src="mediaportalResourceUrl + '/community/img/logo@3x.png'"
          alt="結婚式準備.com"
        />
      </a>
      <span v-if="isLogin" class="navbar__item" id="nav_right">
        <div v-if="isPlanner != 3" class="navbar__item">
          <Mypage />
        </div>
        <div v-else class="navbar__item">
          <PlannerMypage />
        </div>
      </span>
      <div v-else class="navbar__item to_login">
        <a class="button button--link" :href="communityUrl + '/user/sign_in'">
          <p>新規会員登録</p>
          <p>ログイン</p>
        </a>
      </div>

      <span
        v-if="isLogin && isPlanner != 3"
        id="plus_button"
        @click="toggleSelectTab"
      >
        <img
          :src="mediaportalResourceUrl + '/community/img/btn_plus@3x.png'"
          alt="新規作成"
        />
      </span>
      <div
        id="select_tab_wrapper"
        :class="{
          select_tab_open: openSelectTab,
          select_tab_close: !openSelectTab,
        }"
      >
        <img
          :src="mediaportalResourceUrl + '/community/img/btn_close.png'"
          alt="閉じる"
          id="select_close_btn"
          @click="toggleSelectTab"
        />
        <div id="select_btn_wrapper">
          <button class="select_btn" @click.prevent="setReview">
            クチコミを投稿する
          </button>
          <button class="select_btn" @click.prevent="setPlanner">
            掲示板を投稿する
          </button>
          <button class="select_btn select_guide_btn" @click.prevent="goHowto">
            <img
              :src="mediaportalResourceUrl + '/community/img/begginer_icon.png'"
              class="guide_icon"
              alt=""
            />使い方を見る
          </button>
        </div>
      </div>
    </div>
    <SearchForm />
  </nav>
</template>

<script>
import Humberger from "./Humberger.vue";
import Mypage from "./ModalMypage.vue";
import PlannerMypage from "./PlannerMypage.vue";
import SearchForm from "../components/SearchForm.vue";

export default {
  components: {
    Humberger,
    Mypage,
    PlannerMypage,
    SearchForm,
  },
  data() {
    return {
      showForm: false,
      openSelectTab: false,
      baseMediaportalUrl: process.env.VUE_APP_BASE_MEDIAPORTAL_URL,
      mediaportalResourceUri: process.env.VUE_APP_MEDIAPORTAL_RESOURCE_URI,
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    toggleSelectTab() {
      if (this.openSelectTab === false) {
        this.openSelectTab = true;
      } else {
        this.openSelectTab = false;
      }
    },
    async getUser() {
      this.$store.dispatch("auth/getUser");
    },
    // async setPlanner() {
    //   this.$store.commit("planner/setPlanner", null);
    //   this.$router.push("/bbs/new");
    // },
    // async setReview() {
    //   this.$router.push("/review/new");
    // },
    // async goHowto() {
    //   this.openSelectTab = false;
    //   this.$router.push("/review/howto");
    // },
  },
  computed: {
    isLogin() {
      return this.$store.getters["auth/check"];
    },
    isPlanner() {
      return this.$store.getters["auth/typeid"];
    },
    username() {
      return this.$store.getters["auth/username"];
    },
    userid() {
      return this.$store.getters["auth/userid"];
    },
    mediaportalResourceUrl: function () {
      return this.baseMediaportalUrl + this.mediaportalResourceUri;
    },
    communityUrl() {
      return process.env.VUE_APP_BASE_COMMUNICATION_URL;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue